interface State {
    appNotificationBar: object
}

const defaults = () => {
    return {
        appNotificationBar: null
    }
}

export default {
    state: defaults(),
    mutations: {
        appNotificationBarReset (state: State): void {
            Object.assign(state, defaults())
        },
        appNotificationBarSet (state: State, obj: object = null): void {
            //  Sets our notification bar to obj, if obj = null, we close
            state.appNotificationBar = obj
        },
    },
    getters: {
        appNotificationBar (state: State): object {
            return state.appNotificationBar
        }
    }
}
